// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CmL4C","left":"styles_left__1Lcj4"};